export const COLORS_CHART = [
  "#34c38f",
  "#556ee6",
  "#f46a6a",
  "#50a5f1",
  "#f1b44c",
  "#b644b8fa",
  "#FFE652",
  "#ff4de9",
];

export const COLORS_CHART_GROUP_COLUMN = [
  "#50a5f180",
  "#34c38f",
  "#f1b44ca1",
  "#50a5f1",
  "#f1b44c",
  "#b644b8fa",
  "#FFE652",
  "#ff4de9",
];
